export default function decode(string = '') {
  const parser = new DOMParser();
  const dom = parser.parseFromString(
    `<!doctype html><body>${string}`,
    'text/html',
  );
  return dom.body.textContent;
}
